import React from "react";

/** Visual 0-100 meter used in the article intelligence sidebar. */
export default function ImpactMeter({ label, value = 50, tone = "gold", testId }) {
  const v = Math.max(0, Math.min(100, Math.round(value)));
  return (
    <div data-testid={testId} className="font-sans">
      <div className="flex items-baseline justify-between">
        <span className="kicker">{label}</span>
        <span className="meta">{v}/100</span>
      </div>
      <div className="meter-track mt-2">
        <div className={`meter-fill meter-fill-${tone}`} style={{ width: `${v}%` }} />
      </div>
    </div>
  );
}
